module.exports = __webpack_public_path__ + "static/theDot-3c4848a6d477e788904808c194d42869.png";